// ============================================
// ФИЛЬТРАЦИЯ БЛОКОВ ЦЕН ДЛЯ ДЕТСКОГО САДА ПРИ 768px
// ============================================

(function() {
  function init() {
    // Только страница Early Years (детсад): на primary/secondary субтитры карточек другие — фильтр скрывал бы всё.
    if (!document.body || !document.body.classList.contains("kindergarten-page")) {
      return;
    }
  function filterKindergartenPrices() {
    // Работает только при 768px и ниже
    if (window.innerWidth > 768) {
      return;
    }

    const allPriceItems = document.querySelectorAll('.block12_price_item:not(.price-item-clone)');
    
    allPriceItems.forEach(item => {
      // Информационный блок всегда показываем
      if (item.classList.contains('block12_price_info')) {
        return; // Не скрываем информационный блок
      }
      
      const subtitleEl = item.querySelector('.block12_price_subtitle');
      if (!subtitleEl) {
        item.style.display = 'none';
        return;
      }
      
      const subtitleText = subtitleEl.textContent.trim();
      
      // Показываем только нужные блоки
      const allowedSubtitles = [
        'Pre-Nursery и Nursery',
        'Reception',
        'Year 1 - Year 4'
      ];
      
      const isAllowed = allowedSubtitles.some(allowed => subtitleText.includes(allowed));
      
      if (isAllowed) {
        // Показываем только если элемент виден для текущего кампуса и года
        const itemCampus = item.getAttribute('data-campus');
        const selectedCampus = document.getElementById('block12SelectedCampus');
        if (selectedCampus) {
          const currentCampusText = selectedCampus.textContent.trim();
          const campusMap = {
            'Сколково': 'skolkovo',
            'Москва': 'moscow',
            'Горки': 'gorki',
            'Санкт-Петербург': 'spb',
            'Ташкент': 'tashkent'
          };
          const campusId = Object.keys(campusMap).find(key => currentCampusText.includes(key));
          const currentCampus = campusMap[campusId] || 'spb';
          
          if (itemCampus === currentCampus) {
            // Проверяем год
            const selectedYear = document.getElementById('block12SelectedYear');
            let currentYear = '2025-2026';
            if (selectedYear) {
              const yearText = selectedYear.textContent.trim();
              const yearMatch = yearText.match(/(\d{4}-\d{4})/);
              if (yearMatch) {
                currentYear = yearMatch[1];
              }
            }
            
            const itemYear = item.getAttribute('data-year');
            const yearMatch = !itemYear || itemYear === currentYear || itemYear.split(',').includes(currentYear);
            
            if (yearMatch) {
              item.style.display = 'flex';
            } else {
              item.style.display = 'none';
            }
          } else {
            item.style.display = 'none';
          }
        }
      } else {
        item.style.display = 'none';
      }
    });
    
    // Центрируем карусель, если элементов всего 2
    const pricesGrid = document.querySelector('.block12_prices_grid');
    if (pricesGrid) {
      const visibleItems = Array.from(allPriceItems).filter(item => {
        const style = window.getComputedStyle(item);
        return style.display !== 'none' && !item.classList.contains('block12_price_info');
      });
      
      // Добавляем информационный блок в подсчет, если он виден
      const infoBlock = document.querySelector('.block12_price_info');
      let visibleCount = visibleItems.length;
      if (infoBlock) {
        const infoStyle = window.getComputedStyle(infoBlock);
        if (infoStyle.display !== 'none') {
          visibleCount++;
        }
      }
      
      if (visibleCount === 2) {
        pricesGrid.classList.add('block12_prices_grid_centered');
      } else {
        pricesGrid.classList.remove('block12_prices_grid_centered');
      }
    }
    
    // Переинициализируем слайдер после фильтрации
    if (typeof window.reinitPriceSlider === 'function') {
      setTimeout(() => {
        window.reinitPriceSlider();
      }, 100);
    }
  }
  
  // Вызываем при загрузке
  filterKindergartenPrices();
  
  // Вызываем при изменении размера окна
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      filterKindergartenPrices();
    }, 100);
  });
  
  // Вызываем при изменении кампуса
  const campusObserver = new MutationObserver(() => {
    filterKindergartenPrices();
  });
  
  const selectedCampus = document.getElementById('block12SelectedCampus');
  if (selectedCampus) {
    campusObserver.observe(selectedCampus, { childList: true, characterData: true, subtree: true });
  }
  
  // Вызываем при изменении года
  const selectedYear = document.getElementById('block12SelectedYear');
  if (selectedYear) {
    campusObserver.observe(selectedYear, { childList: true, characterData: true, subtree: true });
  }
  
  // Вызываем при клике на селекторы
  const campusBtn = document.getElementById('block12CampusSelectorBtn');
  if (campusBtn) {
    campusBtn.addEventListener('click', () => {
      setTimeout(() => {
        filterKindergartenPrices();
      }, 200);
    });
  }
  
  const yearBtn = document.getElementById('block12YearSelectorBtn');
  if (yearBtn) {
    yearBtn.addEventListener('click', () => {
      setTimeout(() => {
        filterKindergartenPrices();
      }, 200);
    });
  }
  
  // Вызываем при клике на опции кампуса
  document.querySelectorAll('.block12_campus_option').forEach(option => {
    option.addEventListener('click', () => {
      setTimeout(() => {
        filterKindergartenPrices();
      }, 200);
    });
  });
  
  // Вызываем при клике на опции года
  document.querySelectorAll('.block12_year_option').forEach(option => {
    option.addEventListener('click', () => {
      setTimeout(() => {
        filterKindergartenPrices();
      }, 200);
    });
  });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

